module.exports = __webpack_public_path__ + "img/successfulAlertIcon.65d46ca8.svg";